module.exports = __webpack_public_path__ + "img/20180815_145911_032.2778d4b2.jpg";